import type { PageProps, P2pMoneyAbroadPageProps } from "@/types"
import type { FC } from "react"
import { AlinaNemykina, P2pMoneyAbroadHero } from "../p2p-money-abroad"
import { InclusiveFunds } from "../p2p-money-abroad/inclusive-funds"
import { RevenueAndProfits } from "../p2p-money-abroad/revenue-and-profits"
import { WhitePaperProduct } from "../p2p-money-abroad/white-label-product"
import { CTA } from "../p2p-money-abroad/cta"
import { MessageForm } from "../p2p-money-abroad/message-form"

export const P2pMoneyAbroad: FC<PageProps<P2pMoneyAbroadPageProps>> = (props) => {
  return (
    <div>
      <P2pMoneyAbroadHero
        title={props.data.title}
        description={props.data.description}
        heroImage={props.data.heroImage}
      />
      <InclusiveFunds
        header={props.data.inclusiveFundsHeader}
        cards={props.data.inclusiveFundsCards}
        featureCards={props.data.inclusiveFundsFeaturesCards}
      />
      <RevenueAndProfits
        title={props.data.revenueAndProfitTitle}
        values={props.data.revenueAndProfitsValues}
        subtitle={props.data.revenueAndProfitsSubtitle}
      />
      <WhitePaperProduct 
        title={props.data.whiteLabelProductTitle}
        tags={props.data.whiteLabelProductTags}
      />
      <CTA cta={props.data.cta} />
      <MessageForm title="Discover More!"/>
      <AlinaNemykina alinaNemykina={props.data.alinaNemykina} />
    </div>
  )
}